module.exports = __webpack_public_path__ + "static/img/03bg.2142db1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toolbar/03bg.png
// module id = C6Sd
// module chunks = 1